
export class ContactoEmpresa{

    ContactoEmpresaID: number;
    ApellidoPaterno : string;
    ApellidoMaterno : string;
    Nombre : string;
}
